import {EventEmitter, Injectable} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {StorageService} from '../../storage/storage.service';

@Injectable()
export class AppParameterService {
  parametersReady: EventEmitter<boolean>;
  private envelopesData: any[];
  private listEnvelope: SelectItem[];
  private postageData: any[];
  private listPostage: SelectItem[];
  public PRINCIPAL_FILE_EXTENSIONS: string[];

  /**
   * file extensions for PRINCIPAL
   */
  public ANNEX_FILE_EXTENSIONS: string[];

  /**
   * file extensions for DATA
   */
  public DATA_FILE_EXTENSIONS: string[];

  /**
   * file extensions for SPOOL
   */
  public SPOOL_FILE_EXTENSIONS: string[];

  constructor(private storageService: StorageService) {
    this.parametersReady = new EventEmitter();
  }

  public buildEnvelopes(envelopes: any[]) {
    this.envelopesData = envelopes;
    this.listEnvelope = [];
    for (const env of envelopes) {
      this.listEnvelope.push({label: env.sEnvelopeLib, value: env.sEnvelopeID});
    }
  }
  public buildPostages(postages: any[]) {
    this.postageData = postages;
    this.listPostage = [];
    for (const post of postages) {
      this.listPostage.push({label: post.sPostageLib, value: post.sPostageID});
    }
    this.parametersReady.emit(true);
  }
  public getPostages(): SelectItem[] {
    return this.listPostage;
  }
  public getEnvelopes(): SelectItem[] {
    return this.listEnvelope;
  }
  public getExtensions(): SelectItem[] {
    return this.storageService.getAcceptedFilesFromStorage();
  }
}
